import React from 'react';
import { Render } from '../lib/render';
import { defaultConfig } from '../lib/default-ui-config';
import { States } from '../types/props';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { UIConfig } from '../types/ui-config';
import DyteClient from '@dytesdk/web-core';

export default function ({
  meeting,
  config = defaultConfig,
  states,
  iconPack,
  t,
}: {
  meeting: DyteClient;
  config?: UIConfig;
  iconPack?: IconPack;
  states?: States;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  config = config ?? defaultConfig;
  return (
    <Render
      element="dyte-header"
      defaults={{
        config: config,
        meeting,
        states,
        size: 'sm',
        iconPack: iconPack,
        t: t,
      }}
    />
  );
}
